import { Component, OnInit } from "@angular/core";
import * as _ from "lodash";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { SubSink } from "subsink";
import { EventBusService } from "../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TalentPayrollService } from "../../../shared/services/talent-payroll.service";

@Component({
    selector: "modal-import-timecards",
    templateUrl: "./modal-import-timecards.component.html",
    standalone: false
})
export class ModalimportTimecardsComponent implements OnInit {
    constructor(
        private _eventBusService: EventBusService,
        public bsModalRef: BsModalRef,
        public _modalService: BsModalService,
        private talentService: TalentPayrollService,
        private log: NbcLoggerService
    ) {}

    public onSync!: Subject<any>;
    subs: SubSink = new SubSink();

    /*shared from parent application*/
    batchId: any;
    buAccess: any;
    networks: any = [];
    workStates: any = [];
    employeeTypes: any = [];
    sports: any = [];
    eventShowName: any = "";
    importtimecards: any = [];
    files: any = [];
    networkSelected: any = "";
    sportSelected: any = "";
    employeeTypeSelected: any = "";
    contact: any;
    glAccount: any;

    companyCodes: any = [];
    contactsSelectedForUpdate: any = [];
    /*uptil here*/

    costCenterType: any = "wbse";
    showwbse = true;
    showcc = false;
    timecard: any = {};
    selectedDates: any = [];
    displaySelectedDates: any = "";
    fileData: any;
    validExcelFileTypes = [".xlsx"];
    fileContactName: any;
    fileContactSSO: any;

    fileupload() {
        const fileupload = document.getElementById("file-upload");
        fileupload?.click();
    }

    importTimecards(fileInput: any) {
        this.fileData = <File>fileInput.target.files[0];
        this.files.push(this.fileData);
    }

    clearFile(event) {
        this.files = [];
        this.importtimecards = [];
        event.stopPropagation();
    }

    import() {
        const extension = "." + this.fileData.name.split(".").pop();
        if (!_.includes(this.validExcelFileTypes, extension)) {
            this.log.showModalError(
                "The file being imported does not meet the correct excel format, please choose a file in .xlsx format."
            );
            return;
        }
        this.talentService.importTimecards(this.fileData).subscribe(
            (result) => {
                this.importtimecards = result;
                if (this.importtimecards.length > 0) {
                    this.fileContactName =
                        this.importtimecards[0].contact.firstName;
                    this.fileContactSSO = this.importtimecards[0].contact.sso;
                } else {
                    this.log.showModalError("No Records Found.");
                }
            },
            (err) => {
                this.log.showModalError(
                    "Unable to upload file for Timecard import."
                );
            }
        );
    }

    confirm() {
        if (this.contact == null) {
            this.log.showModalError("Please select a contact");
            return;
        }

        if (this.contact.sso !== this.importtimecards[0].contact.sso) {
            this.log.showModalError("Contact SSO does not match SSO in Excel.");
            return;
        }
        this.importtimecards.forEach((item) => {
            item.contact = this.contact;
            item.sport = _.find(this.sports, [
                "id",
                parseInt(this.sportSelected),
            ]);
            item.eventShowName = this.eventShowName;
            item.network = _.find(this.networks, [
                "id",
                parseInt(this.networkSelected),
            ]);
            item.employeeType = _.find(this.employeeTypes, [
                "id",
                this.employeeTypeSelected?.id,
            ]);
            item.glAccount = this.glAccount;
            item.createdByDepartment = {
                id: this.buAccess.departmentId,
            };
            item.timeSheetBatch = {
                id: this.batchId,
            };
        });

        this.talentService
            .upsertTimecards(this.buAccess.businessUnitId, this.importtimecards)
            .subscribe({
                next: (result) => {
                    //this.onSync.next();
                    this.onSync.next(""); //TODO: Revisit
                    this.bsModalRef.hide();
                },
                error: (err) => {
                    this.log.showModalError(
                        "Save Timecard got an error: " + JSON.stringify(err)
                    );
                },
            });
        this.bsModalRef.hide();
    }

    cancel() {
        this.log.trace("cancel");
        this.bsModalRef.hide();
    }

    onContactSelected(data) {
        const contact = data.contact;
        this.contact = contact;
    }

    onSportsChange(selectedSport) {
        this.sportSelected = selectedSport === null ? "" : selectedSport.id;
    }

    onNetworkChange(selectedNetwork) {
        this.networkSelected =
            selectedNetwork === null ? "" : selectedNetwork.id;
    }

    onEmployeeTypeChange(selectedEmployee) {
        this.employeeTypeSelected =
            selectedEmployee === null ? "" : selectedEmployee;
    }

    ngOnInit() {
        this.onSync = new Subject();
        this.subs.sink = this._eventBusService.on("onContactSelected", (data) =>
            this.onContactSelected(data)
        );
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
